var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecOffer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 3.75033C3.33325 2.59973 4.26599 1.66699 5.41659 1.66699H10.1934C10.746 1.66699 11.2759 1.88649 11.6666 2.27719L15.2231 5.83366C15.6138 6.22436 15.8333 6.75426 15.8333 7.3068V16.2503C15.8333 17.4009 14.9005 18.3337 13.7499 18.3337H5.41659C4.26599 18.3337 3.33325 17.4009 3.33325 16.2503V3.75033ZM5.41659 10.0003C5.41659 9.42503 5.88296 8.95866 6.45825 8.95866H12.7083C13.2835 8.95866 13.7499 9.42503 13.7499 10.0003C13.7499 10.5756 13.2835 11.042 12.7083 11.042H6.45825C5.88296 11.042 5.41659 10.5756 5.41659 10.0003ZM6.45825 13.1253C5.88296 13.1253 5.41659 13.5917 5.41659 14.167C5.41659 14.7423 5.88296 15.2087 6.45825 15.2087H12.7083C13.2835 15.2087 13.7499 14.7423 13.7499 14.167C13.7499 13.5917 13.2835 13.1253 12.7083 13.1253H6.45825Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecOffer);
export default __webpack_public_path__ + "static/media/rec-offer.cf8c4789d5bcfe6d4d2841f1055a39d9.svg";
export { ForwardRef as ReactComponent };